import {bounceMessage} from '../../../layout/userMessages/UserMessage';
import {removeTagsFromText} from '../emailSubjectTextEditor/EmailSubjectTextEditor';

export const WHATSAPP_MAX_SIZE = 5 * 1024 * 1024; // 5MB
export const WHATSAPP_SUPPORTED_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const WHATSAPP_SUPPORTED_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
export const WHATSAPP_MAX_TEXT_LENGTH = 1024;

export const validateWhatsAppImage = (file, t) => {
    if(file.size > WHATSAPP_MAX_SIZE) {
        bounceMessage(t('whatsappImageSizeError'), 'warning');
        return false;
    }
    
    if(!WHATSAPP_SUPPORTED_TYPES.includes(file.type.toLowerCase())) {
        bounceMessage(t('whatsappImageTypeError'), 'warning');
        return false;
    }
    
    return true;
};

export const isImagePathSupported = (imagePath) => {
    if(!imagePath) return false;
    
    const lowerPath = imagePath.toLowerCase();
    
    return WHATSAPP_SUPPORTED_EXTENSIONS.some(ext => lowerPath.endsWith(ext));
};

export const validateWhatsAppText = (content, t) => {
    let processedContent = content.replace(/<\/p><p>/g, '\n');
    const cleanText = removeTagsFromText(processedContent);
    
    if(cleanText.length > WHATSAPP_MAX_TEXT_LENGTH) {
        bounceMessage(t('whatsappTextTooLongError'), 'warning');
        return false;
    } 
    return true;
};

